<template>
  <b-container fluid>
    <div class="silder-l">
      <b-row>
        <b-col md="3">
          <div class="upslider">
            <h3 style="display: flex;
            align-content: flex-start;
            justify-content: space-around; color:#ac7601">-: योजनेबाबत :-</h3>
            <marquee direction="up" scrolldelay="100" onclick="this.stop()" onMouseOver="this.stop()" onMouseOut="this.start()"  class="marque">
              <p style="color: #ac7601;">· इतर मागासप्रवर्गातील महिलांना स्वयंरोजगार उपलब्ध होऊन त्यांना सक्षम करणे.
              </p>
              <p style="color: #ac7601;">· इतर मागासप्रवर्गातील गरीब, होतकरु, परितक्त्या महिलांचे सक्षमीकरण करुन त्यांना स्वावलंबी व आत्मनिर्भर करणे.
              </p>
              <p style="color: #ac7601;">· सदर योजना राज्यातील महिला बचत गटातील इतर मागासप्रवर्गातील महिलांकरीता लागु आहे.
              </p>
              <p style="color: #ac7601;">· महिला आर्थिक विकास महामंडळाच्या CMRC (लोकसंचालित साधनकेंद्र) मार्फत शिफारस केलेल्या महिला बचत गटांत किमान 50% इतर मागासप्रवर्गातील महिला असतील असा बचत गट व्याज परतावा योजनेस पात्र राहील.
              </p>
              <p style="color: #ac7601;">· पात्र महिलांचे किमान वय 18 वर्षे आणि कमाल वय 60 वर्षे इतके असावे.
              </p>
              <p style="color: #ac7601;">· पात्र महिला बचत गटास प्रथम टप्प्यास रु.5.00 लक्ष पर्यंत कर्ज बँकेकडून उपलब्ध करुन देण्यास मान्यता देण्यात येईल.
              </p>
              <p style="color: #ac7601;">· प्रथम टप्प्यातील कर्ज नियमित परतफेडीनंतर सदर बचत गट द्वितीय टप्प्यात रु.10.00 लक्ष पर्यंत कर्ज बँकेकडून मंजुर करुन घेण्यास पात्र होईल.</p>
              <p style="color: #ac7601;">· बँकेकडून मंजुर केलेल्या कर्ज रक्कमेवरील कमाल 12% व्याजाच्या मर्यादेत व्याज परतावा ओबीसी महामंडळामार्फत अदा करण्यात येईल.</p>
            </marquee>
          </div>
        </b-col>
        <b-col md="6">
          <slider></slider>

        </b-col>
        <b-col md="3">
          <div class="login-wrapper">
            <div class="login-box-inner">
              <h6 class="login-header">Member Login</h6>

              <img src="../assets/images/login-user.png" class="login-img" />

              <b-row>
                <b-col>
                  <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-alert :show="showDismissibleAlert" dismissible @dismissed="showDismissibleAlert = false"
                      :variant="variant">{{ alertText }}</b-alert>
                    <div class="form-group">
                      <small for="exampleInputEmail1" class="label-text">
                        User Name
                        <span>*</span>
                      </small>
                      <b-input type="text" :formatter="format" lazy-formatter v-model="form.userName" required
                        class="form-control" size="sm" id="inputUserID" aria-describedby="emailHelp"
                        placeholder="Enter Your UserName"></b-input>
                    </div>

                    <div class="form-group pass-form-group">
                      <small for="exampleInputEmail1" class="label-text">Password*</small>
                      <b-input type="password" :formatter="format" lazy-formatter v-model="password_text"
                        class="form-control" size="sm" id="inputPwd" aria-describedby="emailHelp"
                        placeholder="Enter Password"></b-input>
                    </div>
                    <captcha :callSuccess="captchaOk" color="black" resolve="text" :isAuth="auth"></captcha>
                    <div class="login-btn-wrap flex-s">
                      <button class="btn btn-primary btn-sm login-btn" style="background-color: #ac7601;" type="submit">
                        Login
                      </button>
                      <b-btn variant="link" size="sm" class="forgot-pass-btn" @click="showModal">Forgot Password?</b-btn>
                      <Spinner size="16" message="Loading..." v-if="isLoading"></Spinner>
                    </div>
                    <div class="forgot-pass-wrap"></div>
                  </b-form>
                  <div class="sign-up-wrap">
                    <b-btn variant="link" size="sm" to="/EProfile" class="sign-up-btn">
                      New User?
                      <span class="sign-up-span">Signup Now</span>
                    </b-btn>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>

     
    </div>

    <b-row class="mt-5 ">

      <b-col class=" -col">
        <StatComponent2></StatComponent2>
      </b-col>

    </b-row>

    <b-modal ref="myModalRef" title="Forgot Password?" hide-footer>
      <ForgotPassword @close="hideModal()"></ForgotPassword>
    </b-modal>
  </b-container>
</template>

<script>
import StatComponent2 from "@/components/Portal/StatComponent2";
import StatComponent3 from "@/components/Portal/StatComponent3";
import apis from "@/apis";
import ForgotPassword from "@/components/ForgotPassword";
import PortalNavbar from "@/components/PortalNavbar";
import Spinner from "vue-simple-spinner";
import captcha from "@/components/Captcha/Captcha.vue";
import sha256 from "js-sha256";
import slider from "./Slider.vue"

export default {
  components: {
    slider,
    Spinner,
    PortalNavbar,
    ForgotPassword,
    StatComponent2,
    StatComponent3,
    captcha,
  },
  data() {
    return {
      auth: false,
      dismissSecs: 20,
      dismissCountDown: 0,
      form: {
        userName: "",
        Password: "",
      },
      slide: 0,
      sliding: null,
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      password_text: ""
    };
  },
  methods: {
    captchaOk() {
      this.auth = true;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    onSubmit(evt) {
      evt.preventDefault();

      if (this.auth) {
        this.isLoading = true;
        this.showDismissibleAlert = false;
        var md = sha256.create();
        md.update(this.password_text);
        var hashText = md.hex();

        this.form.Password = hashText;

        let promise = apis.login(this.form);

        promise
          .then((response) => {
            if (response.status == 200) {
              let userary = response.body;
              if (userary.length == 0) {
                this.alertText = "User name or Password is invalid";

                this.variant = "warning";
                this.showDismissibleAlert = true;
                this.auth = false;
              } else {
                this.$store.dispatch("login", {
                  token: response.body[0].SessionID,
                  user: response.body[0],
                });
                this.$store.dispatch(
                  "setUserDistrict",
                  response.body[0].DistrictID
                );
                if (response.body[0].RoleID == 0) {
                  this.$router.replace("/dashboard");
                } else {
                  this.$router.replace("/admindashboard");
                }
              }
            } else {
              this.alertText = response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          })
          .catch((err) => {
            this.alertText = err.message;
            this.showDismissibleAlert = true;
            this.variant = "danger";
            this.isLoading = false;
          });
      } else {
        this.$dialog.alert("Please enter Captcha");
      }
    },
    onReset(evt) { },
  },
  mounted() {
    this.dismissCountDown = this.dismissSecs;
  },
};
</script>

<style scoped>
body {
  background: #e8eff9 !important;
}

ul {
  padding: 0;
  margin: 0;
}

.top-land {
  /*border-bottom : solid 2px #ccc;*/
  padding-top: 10px;
  padding-bottom: 10px;
}

.navbar {
  padding: 0 !important;
  background: #ac7601 !important;
}

.navbar-brand {
  font-size: 12pt !important;
  color: #ccc !important;
}

.login-box-inner {
  background: #f1f1f1;
  padding: 25px 25px;
  border: 1px solid #d3d3d3;
  border-radius: 0 12px 12px 0;
  height: 530px;
}

.nav-item:hover .login-box {
  display: block;
}

.containerx {
  width: 50%;
  height: 95%;
  margin-bottom: 1em auto;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin-left: -5px;
}

.marquee {
  top: 6em;
  position: relative;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move! */
@keyframes marquee {
  0% {
    top: 8em;
  }

  100% {
    top: -11em;
  }
}

/* Make it look pretty */
.microsoft .marquee {
  margin: 0;
  padding: 0 1em;
  line-height: 1.5em;
  font: 1em "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

.microsoft:before,
.microsoft::before,
.microsoft:after,
.microsoft::after {
  left: 0;
  z-index: 1;
  content: "";
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 2em;
  background-image: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));
}

.microsoft:after,
.microsoft::after {
  bottom: 0;
  transform: rotate(180deg);
}

.microsoft:before,
.microsoft::before {
  top: 0;
}

.rounded-circle {
  width: 100%;
  max-width: 200px;
  margin-bottom: 10px;
}

.guidelines {
  background: url(../assets/pdfIcon.png) no-repeat left 1px;
  padding-left: 28px;
  display: block;
  /* float: left; width: 100%;*/
  /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font: 0.8rem "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

.newsnevents {
  display: block;
  /* float: left; width: 100%;*/
  /* line-height: 22px; */
  margin-left: 5px;
  color: #000 !important;
  margin-bottom: 0.1rem;
  font-size: 0.8rem;
}

/* UI changes by Akshay 15-08-2019 */

.login-row-wrap {
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px !important;
  margin-bottom: 30px;
}

.login-box-inner .login-header {
  text-align: center;
  font-weight: bold;
  color: #000;
  font-size: 20px;
}

.upslider {
  padding: 10px;
  margin-left: 9px;
  background: #f1f1f1;
  border: 0.1px solid;
  min-height: 520px;
  max-height: 100vh;
  overflow: hidden;
  width: 100%;
}

.marque {
  margin-top: 8px;
  display: flex;
  justify-content: space-around;
}

.login-box-inner .login-img {
  width: 50px;
  display: block;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
}

.login-box-inner .label-text {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 7px;
  display: block;
  color: #ac7601;
}

.new_loginf input {
  height: 40px !important;
  color: #ac7601;
  box-shadow: 0 8px 8px 4px #aeaeae90;
  border-radius: 2px;
}

.new_loginf input::placeholder {
  color: #ac7601;
}

.login-box-inner .form-control {
  font-size: 13px;
  padding-top: 10px;
  padding-bottom: 10px;

}

.login-btn-wrap {
  margin: auto;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 10px;
}

.login-btn-wrap .login-btn {
  background: #ac7601;
  border: none;
  border-radius: 4px;
  padding: 8px 40px;
  /*margin-left: -110px;*/
}

.bg-blue h4[data-v-0b029c26] {
  font-weight: bolder;
}

.forgot-pass-btn {
  font-size: 13px;
  color: #ac7601;
  margin-top: 10px;
  font-weight: bold;
  text-align: right;

}

.sign-up-wrap {
  width: fit-content;
  margin: auto;
}

.sign-up-wrap .sign-up-btn {
  color: #ac7601;
  font-weight: bold;
  font-size: 13px;
}

.pass-form-group {
  margin-top: 20px;
}

/* *********** */

.container-fluid {
  overflow: hidden;
}

.silder-l .col-xl-9 {
  padding: 0 !important;
}

.login-wrapper {
  max-width: 95%;

  margin-top: 5px;
}

@media (max-width: 420px) {
  .login-wrapper {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
}


@media (max-width: 1199px) {
  .stat-col {
    margin-left: auto;
    margin-right: auto;
  }
}


.login-box-mobile {
  display: none;
}

@media (max-width: 991px) {
  .login-box-mobile {
    display: block;
  }

  .login-box-desktop {
    display: none;
  }

  p .stat-col {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 992px) and (max-width: 1100px) {
  .login-btn-wrap .login-btn {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
  }

  .forgot-pass-btn {
    float: none;
    text-align: center;
  }
}

@media (max-width: 419px) {
  .login-box-inner {
    padding-left: 15px;
    padding-right: 15px;
  }

  .login-wrapper {
    padding-left: 0;
    padding-right: 0;
  }

  .login-btn-wrap .login-btn {
    padding-left: 30px;
    padding-right: 30px;
  }
}

.new_loginf {
  bottom: -385px;
  z-index: 99994;
  position: absolute;
  left: 468px;
}

.newlogin {
  margin: 2% 12% 0%;
  background: #ffffff90;
  padding: 1% 0 2% 0;
  height: 77px;
}

.silder-l {
  position: relative;
  margin-top: 5px;
}

.bg-blue {
  color: #fff !important;
  margin: 1%;
  padding: 1%;
}

.bg-blue p {
  color: #fff;
}

.bg-blue h4 {
  font-weight: 600;
  font-size: 1.2rem;
}

hr {
  background-color: #ac7601;
}

.bg-blue p[data-v-0b029c26] {
  color: #fff;
  font-size: 1rem;
}

body p {
  font-family: 'Open Sans';
  line-height: 26px;
  color: #555555;
  margin: 0;
}
.flex-s{
  display: flex;
}
button.btn.btn-primary.btn-sm.login-btn {
  background: #ac7601;
  border: none;
  border-radius: 4px;
  padding: 8px 40px;
}</style>



// WEBPACK FOOTER //
// src/components/LoginNewHome.vue